/**
 * Recent-searches storage for the autosuggest dropdown.
 *
 * Keeps the last N suggestion clicks in localStorage so returning visitors
 * can jump back to what they were looking at. We persist the same shape the
 * server returns so the UI can re-render them with one component.
 */

const STORAGE_KEY = "vd_recent_searches_v1";
const MAX_ITEMS = 6;

const safeParse = (raw) => {
  try { return JSON.parse(raw) || []; } catch { return []; }
};

export const getRecentSearches = () => {
  if (typeof window === "undefined") return [];
  return safeParse(window.localStorage.getItem(STORAGE_KEY));
};

export const pushRecentSearch = (item) => {
  if (typeof window === "undefined" || !item || !item.href) return;
  const existing = getRecentSearches().filter((x) => x.href !== item.href);
  const next = [{ ...item, ts: Date.now() }, ...existing].slice(0, MAX_ITEMS);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
};

export const clearRecentSearches = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
};
